import React from 'react'
import { CustomDropdownItemOption, DropDownItemOptionComponentProps } from './SelectDropdown'
import classNames from 'classnames'
import { useGetAllUsersQuery } from '../../store/user/user'
import { selectAccountId, selectSafeAuthenticatedUser } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'
import { UserTag } from '../../apps/professional-app/fa/UserTag'

export const UserTagDropdownItemOption: React.FC<DropDownItemOptionComponentProps> = ({ optionId, optionLabel, onClick, selected, disabled }) => {
  const accountId = useAppSelector(selectAccountId)
  const currentUser = useAppSelector(selectSafeAuthenticatedUser)

  const { data: users } = useGetAllUsersQuery({ accountId, identityTypes: ['idp', 'external'] })

  const user = users?.data.find((u) => u.id === optionId)
  const isUnavailable = selected || disabled

  return (
    <CustomDropdownItemOption
      role='button'
      onClick={isUnavailable ? () => {} : onClick}
      aria-disabled={isUnavailable}
      className={classNames('d-flex gap-2 align-items-center', { 'upload-user-dropdown-disabled-option': isUnavailable })}
    >
      {user && user.type ? <UserTag userType={user.id === currentUser.id ? 'current' : user.type} /> : null}
      {optionLabel}
    </CustomDropdownItemOption>
  )
}
